import React from "react";
import { IonModal, IonSpinner } from "@ionic/react";

const ActivityConfirmModal = ({
  isOpen,
  onClose,
  challenge,
  onConfirm,
  isLoading,
}) => {
  if (!challenge) return null;

  // Backend decides which calendar day we're asking about, via
  // participation.attributes.pending_activity_date. This handles evening
  // challenges where the confirmation happens the next morning (the user is
  // confirming yesterday's bed-time, not today's).
  //
  // Fallback to "now" when the field isn't present (older API response shape).
  const pendingIso =
    challenge.attributes?.participation?.attributes?.pending_activity_date;
  const activityDate = pendingIso ? new Date(pendingIso) : new Date();

  const formattedDate = activityDate.toLocaleDateString("it-IT", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });

  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose} className="activity-confirm-modal">
      <div className="activity-confirm-content">
        <h2>Conferma attività</h2>
        <p className="activity-challenge-name">
          Sfida: "{challenge.attributes.title}"
        </p>

        <p className="activity-question">
          Hai completato l'attività di<br />
          <strong>{formattedDate}</strong>?
        </p>

        <div className="activity-actions">
          <button className="cancel-btn" onClick={onClose} disabled={isLoading}>
            Non oggi
          </button>
          <button className="confirm-btn" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? <IonSpinner name="crescent" /> : "Sì, fatto"}
          </button>
        </div>
      </div>
    </IonModal>
  );
};

export default ActivityConfirmModal;
